import { connect } from 'react-redux'

import { IStoreState, IAppliedPromotion } from '../../../types/index'

import AppliedPromotions from '../../../components/riders/riderdetails/promotions/AppliedPromotions'

import { getAppliedPromotions, deleteAppliedPromotion } from '../../../state/actions/riders'

interface IAppliedPromotionsProps {
  userId: string
}

export function mapStateToProps(state: IStoreState, ownProps: IAppliedPromotionsProps) {
  const rider = state.riders.items[ownProps.userId]
  const appliedPromotions = rider ? rider.appliedPromotions : undefined
  return {
    appliedPromotions: Object.values(appliedPromotions || {})
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getAppliedPromotions: (userId: string) => dispatch(getAppliedPromotions(userId)),
    deleteAppliedPromotion: (promotionId: string, walletId: string, userId: string) =>
      dispatch(deleteAppliedPromotion(promotionId, walletId, userId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppliedPromotions)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/AppliedPromotions.ts